import { createAsyncThunk } from '@reduxjs/toolkit';
import { getConnectwiseBoardStatuses } from 'services/connectwise';

interface IProps {
  psaId: number;
  boardId: number;
}

export const ThunkGetConnectwiseBoardStatuses = createAsyncThunk(
  'connectwise/getConnectwiseBoardStatuses',
  ({ psaId, boardId }: IProps) =>
    getConnectwiseBoardStatuses(psaId, boardId)
      .then(res => res.data)
      .then(data => data.sort((a, b) => a.name.localeCompare(b.name))),
);
